import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ion-margin-vertical" }
const _hoisted_5 = {
  key: 0,
  class: "ion-margin-vertical"
}
const _hoisted_6 = { class: "ion-margin-vertical" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "ion-margin-vertical" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_14 = { class: "ion-text-center" }
const _hoisted_15 = { class: "ion-text-center" }
const _hoisted_16 = { class: "ion-text-center" }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (!_ctx.dataLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_page, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_spinner),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('LoadingData')), 1)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_BaseLayout, null, {
          title: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Dashboard')), 1)
              ]),
              _: 1
            })
          ]),
          content: _withCtx(() => [
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t('Welcome')) + ", " + _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name) + " !", 1))
              : _createCommentVNode("", true),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('MyTools')), 1),
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-start ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('cetaMarge')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_ion_text, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('cetaMargeGroupSelectionText')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_auto_fill_select, {
                                  options: _ctx.groups,
                                  modelValue: _ctx.selectedGroupMembership,
                                  "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroupMembership) = $event)),
                                    _ctx.handleSelectedGroupMember
                                  ],
                                  searchField: "name",
                                  label: _ctx.translations[_ctx.currentLanguage].Group,
                                  placeholder: _ctx.translations[_ctx.currentLanguage].Search
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" >")
                                  ]),
                                  _: 1
                                }, 8, ["options", "modelValue", "label", "placeholder", "onUpdate:modelValue"]),
                                (_ctx.memberships.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_component_ion_text, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('cetaMargeMemberSelectionText')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createVNode(_component_auto_fill_select, {
                                        options: _ctx.memberships,
                                        searchField: "member_name",
                                        modelValue: _ctx.selectedMembership,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMembership) = $event)),
                                        label: _ctx.translations[_ctx.currentLanguage].Member,
                                        placeholder: _ctx.translations[_ctx.currentLanguage].Search
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" >")
                                        ]),
                                        _: 1
                                      }, 8, ["options", "modelValue", "label", "placeholder"])
                                    ]))
                                  : (_ctx.selectedGroupMembership)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createVNode(_component_ion_text, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('GroupHasNoMember')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                (_ctx.selectedMembership)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 2,
                                      color: "primary",
                                      href: `/exploitation/${_ctx.selectedMembership.company_slug}/cultures/`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('SeeCampaignData')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["href"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_8,
            (_ctx.groups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('MyGroups')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ion_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('cetaMargeGroupSelectionText')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_auto_fill_select, {
                    options: _ctx.groups.slice(1),
                    searchField: "name",
                    modelValue: _ctx.selectedGroup,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedGroup) = $event)),
                    label: _ctx.translations[_ctx.currentLanguage].Group,
                    placeholder: _ctx.translations[_ctx.currentLanguage].Search
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" >")
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue", "label", "placeholder"]),
                  (_ctx.selectedGroup)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.selectedGroup.name), 1),
                        (_ctx.selectedGroup.members.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('GroupMembers')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Company')), 1),
                                _hoisted_13
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGroup.members, (member, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", _hoisted_14, _toDisplayString(member.member_name), 1),
                                    _createElementVNode("td", _hoisted_15, _toDisplayString(member.company_name), 1),
                                    _createElementVNode("td", _hoisted_16, [
                                      _createVNode(_component_ion_button, {
                                        color: "primary",
                                        href: `/exploitation/${member.company_slug}/`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('SeeCompanyData')), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["href"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('GroupHasNoMember')), 1)
                                ]),
                                _: 1
                              })
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}